<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  etcManageEdit,
  etcManageDetail,
} from 'api/service';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/service/etc/manage/edit',
      formComponents: ['baseForm'],
      editParams: {
        type: 1,
      },

      // 需要对比的参数
      compareParams: {
        etcId: '',
        serviceName: '',
        state: '',
        bindVehicle: '',
        xlCardType: '',
        paymentType: '',
        accountPeriodRemark: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: etcManageDetail,
    editApi: etcManageEdit,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
